import { trackAnalyticsEvent } from '../track'

interface TrackColumnToggledParams {
  page: string
  column: string
  isVisible: boolean
}

/**
 * Fired when a user adds or removes a column from the properties picker.
 * `is_visible` carries the resulting state (the state *after* the toggle), so
 * "most-added column" is `column_toggled` broken down by `column` filtered to
 * `is_visible = true`.
 */
export function trackColumnToggled({ page, column, isVisible }: TrackColumnToggledParams) {
  trackAnalyticsEvent('column_toggled', {
    page,
    column,
    is_visible: isVisible
  })
}
